import { render, staticRenderFns } from "./StaffDailyRosterGrid.vue?vue&type=template&id=8a80bb74"
import script from "./StaffDailyRosterGrid.vue?vue&type=script&lang=js"
export * from "./StaffDailyRosterGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports